<template>
  <router-view />
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

const TARGET_URL = 'https://bsh.yw.hnzhwlkj.cn'

const isPcDevice = () => {
  if (typeof navigator === 'undefined') return false
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return !mobileRegex.test(navigator.userAgent || '')
}

const redirectIfPc = () => {
  if (typeof window === 'undefined') return
  if (isPcDevice()) {
    window.location.replace(TARGET_URL)
  }
}

const handleResize = () => {
  redirectIfPc()
}

onMounted(() => {
  redirectIfPc()
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', handleResize)
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', handleResize)
  }
})
</script>

<style>
html,body,#app { height: 100%; margin: 0; }
</style>
